<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>物业管理</el-breadcrumb-item>
      <el-breadcrumb-item>账单配置</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item v-if="user.username == 'admin'" label="选择部门">
         <el-select v-model="formInline.depId" placeholder="请选择部门"  size="small"  @change="getData">
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.departmentName"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handelAdd">添加</el-button>
      </el-form-item>

    </el-form>

   <el-table  :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
    style="width: 100%;"  stripe :max-height="tableHeight">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>

      <el-table-column  prop="departmentName" label="公司名称" show-overflow-tooltip>
      </el-table-column>
    	<el-table-column  prop="date" label="账单日期" show-overflow-tooltip>
      </el-table-column>
     <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope">
          <prems-button size="mini"   perms="p:detail" @click="handleEdit(scope.row)" label="编辑" />
          <prems-button size="mini" type="danger"  perms="p:delete" @click="deleteInfo(scope.row)" label="删除" />

       <!--   <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger"    @click="deleteInfo(scope.row)">删除</el-button>
          <el-button size="mini" type="primary"   @click="handleRecharge(scope.$index, scope.row,'1')">充值</el-button>
          <el-button size="mini" type="warning"   @click="handleRecharge(scope.$index, scope.row,'2')">退款</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="formInline" @callFather="callFather" v-if="showPage"></Pagination> -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="35%" @click="editFormVisible = false" :close-on-click-modal="false">
    	<el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item v-if="user.username == 'admin'" label="选择部门">
           <el-select v-model="editForm.depId" placeholder="请选择部门"  size="small" @change="deptChange">
              <el-option
                v-for="item in deptList"
                :key="item.id"
                :label="item.departmentName"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
    		<el-form-item label="账单日期" prop="date">
           <el-row>
             <el-col :span="22">
               <el-input size="small" v-model="editForm.date" type="number" @input="numberChange(arguments[0],31)"
            @change="numberChange(arguments[0],31)"  placeholder="请输入账单日期"></el-input>
             </el-col>
             <el-col :span="2">
               <el-tooltip placement="top" effect="light" style="padding: 10px;">
                 <div slot="content">
                   <p>1.出账单日期</p>
                   <p>2.输入日期的当日,生成到前一天截止的数据.如输入15,则生成上月15到本月14的账单</p>
                   <p>3.格式：不能大于31</p>
                 </div>
                 <i class="el-icon-warning"></i>
               </el-tooltip>
             </el-col>
           </el-row>

    		</el-form-item>
    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="editFormVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="submitForm('editForm')">保存</el-button>
    	</div>
    </el-dialog>




  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import PremsButton from "@/views/permission/PreButtom";
  import { getDepartmentTerminalInfoLis } from '../../api/energyMG'
  import {
    saveAndModifyConfig,
    findRoomConfig,
    removeConfig
  } from '../../api/payMG.js'

  export default {
    data() {
      return {
        formInline: {
          pageSize:10,
          currentPage:1,
          depId:'',
          total:0,
          contractName:"",
          roomName:'',
          contractor:'',
        },
        saveLoad:false,
        totalFee:"",
        users:[],
        roomList:[],
        editForm:{
          date:"",
          depId:'',
        },
        pageparm:{

        },
        rtitle:"",
        rechargeFormVisible:false,
        setLoading:false,
        tableHeight:0,
        title:"",
        loading:false,
        meterPointName:"",
        editFormVisible:false,
        dataList:[],
        deptList:[],
        user:{},
        showPage:true,
        reditForm: {
        	totalFee:"",
        	appletUserId:'',
          roomId:"",
        	mark:"",
          roomType:"63",
          payType:'2',
        },
        dayStr:[],

        money:{
          water:'',
          wuYe:"",
        },

        rules: {
        	date: [{required: true,message: '请输入账单日期',trigger: 'blur'}],


        	// roomNum:[{validator:validatePass,trigger:'change' }]

        },

        ContractList:[],
      }
    },
    mounted(){
      this.$nextTick(() => {
      	this.tableHeight = window.innerHeight - 300
      })
    },
    created(){
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.editForm.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
      this.formInline.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId

      this.getData()
      this.getJzData()



    },
    components: {
      Pagination,
      PremsButton
    },
    methods:{
      deptChange(e){
        this.editForm.depId = e
      },
      getJzData:function(){
      	return new Promise((resolve,reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if(res.status == 1){
      				let arr = []
      				this.deptList = res.data.menuDepList
      			}
      			else{
      				this.$message.error(res.msg)
      			}
      		})
      	})
      },
      changeType(e){
        if(this.reditForm.roomType == '63'){
          this.dForm.blance = this.money.water
        }else{
           this.dForm.blance = this.money.wuYe
        }
      },

      numberChange (val,maxNum) {

       this.$nextTick(()=>{
          //比较输入的值和最大值，返回小的
          let num = Math.min(Number(val),maxNum)
          //输入负值的情况下， = 0（可根据实际需求更该）
          if(num<0) {
              this.editForm.date = 1
          }else {
              //反之
               this.editForm.date  = num
          }
       })
      },


      getData(){
        this.loading = true
        findRoomConfig(this.formInline).then(res => {
          this.loading = false
          if(res.status == 1){
            this.dataList = res.data.data
            this.formInline.total = res.data.totalCount

          }else{
            this.$message.error(res.msg)
          }
        })
      },
      handelAdd(){
        this.editFormVisible = true
        this.title = '添加'
        this.editForm.id = ""
        this.editForm.depId = ''
        this.editForm.date = ''
      },
      handleEdit(row){
        this.title = '编辑'
        this.editFormVisible = true
        this.editForm.id = row.id
        this.editForm.depId = row.departmentId
        this.editForm.date = row.date
      },
      search(){
        this.getData()
      },
      callFather(parm){
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData()
      },

      deleteInfo(row){
        this.$confirm('确定要删除吗?', '信息', {
        		confirmButtonText: '确定',
        		cancelButtonText: '取消',
        		type: 'warning'
        	})
        	.then(() => {
        		// 删除
        		removeConfig({
        				 configId: row.id,

        			})
        			.then(res => {
        				if (res.status == 1) {
        					this.$message({
        						type: 'success',
        						message: '已删除!'
        					})
        					this.getData()
        				} else {
        					this.$message({
        						type: 'info',
        						message: res.msg
        					})
        				}
        			})
        			.catch(err => {
        				this.loading = false
        				this.$message.error('删除失败，请稍后再试！')
        			})
        	})
        	.catch(() => {
        		this.$message({
        			type: 'info',
        			message: '已取消删除！'
        		})
        	})
      },
      getMeterInfoList() {
      	this.loadMeter = true
      	let param = {
      		meterPointName: this.meterPointName,
      		energyType:15,
      		priceConfigId:this.curPriceId
      	}
      	findAllMeterInfoList(param).then(res => {
      		this.loadMeter = false
      		if (res.status == 1) {

      			this.MeterInfoList = res.data

      			//this.setChoisMeter(row)
      		} else {
      			this.$message({
      				type: 'info',
      				message: res.msg
      			})
      		}
      	})
      	.catch(err => {
      		this.loadMeter = false
      		this.$message.error('获取数据失败，请稍后再试！')
      	})
      },
      submitForm(){

       this.editForm.date = this.editForm.date < 10 ? '0'+this.editForm.date:this.editForm.date

      
        this.$refs['editForm'].validate(valid => {
        	if(valid){
            if(this.title == '添加'){
              this.add()
            }else{
              this.update()
            }
          }
        })
      },
      add(){
        saveAndModifyConfig(this.editForm).then(res => {
          if(res.status == 1){
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          }else {
            this.$message.error(res.msg)
          }
        })
      },
      update(){
        saveAndModifyConfig(this.editForm).then(res => {
          if(res.status == 1){
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          }else {
            this.$message.error(res.msg)
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/property/billset.vue